/**
 * Premium Lite: the backend refuses what the member's plan doesn't include
 * with 403 `{ reason: "entitlement_required", permission, message }`. The
 * global interceptors (services/authGuard.js) turn that into one app-wide
 * event, and <EntitlementPromptHost> shows the CRM popup ("Passa a Premium"),
 * so no screen needs its own handling. Other 403s are untouched.
 */
export const ENTITLEMENT_REQUIRED_EVENT = "ds:entitlement-required";

export const isEntitlementRequired = (status, body) =>
  status === 403 && body?.reason === "entitlement_required";

/**
 * What a request helper rejects with when the refusal was an entitlement one:
 * the popup is already on screen, so callers skip their own error toast.
 */
export const ENTITLEMENT_REFUSED = "__entitlement_required__";

export const isEntitlementRefusal = (value) =>
  value === ENTITLEMENT_REFUSED || value?.message === ENTITLEMENT_REFUSED;

export const announceEntitlementRequired = (body) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(ENTITLEMENT_REQUIRED_EVENT, {
      detail: {
        permission: body?.permission ?? null,
        message: body?.message ?? body?.error?.message ?? "",
      },
    }),
  );
};
